<!--
 * @Author: your name
 * @Date: 2021-09-16 11:25:45
 * @LastEditTime: 2022-06-10 14:40:54
 * @LastEditors: LAPTOP-JM4BAR46
 * @Description: In User Settings Edit
 * @FilePath: \newBj-admin\src\views\center-business\order\source\index.vue
-->
<template>
  <div class="app-container">
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :get-action="queryApi"
      :serial="serial"
      :selection="selection"
      :before-reset-search="beforeResetSearch"
      @handleSelectionChange="handleSelectionChange"
      @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
    >
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('OrderRuless.Doc')" prop="orderSn">
            <BjInputCode
              v-model="queryParams.orderSn"
              :placeholder="$t('OrderRuless.number')"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('OrderRuless.Channel')" prop="channel">
            <BjSelectLov v-model="queryParams.channel" lov-code="SCHL.CHANNEL_TYPE" :placeholder="$t('OrderRuless.Channel')"/>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('OrderRuless.Store')" prop="shopCode">
            <BjSelectStore v-model="queryParams.shopCode" multiple option-value="code" :placeholder="$t('OrderRuless.Store')"/>
          </el-form-item>
        </el-col>
        <!-- #ifndef OPEN-SOURCE -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('OrderRuless.Sourcing')" prop="sourcingStatus">
            <BjSelectLov
              v-model="queryParams.sourcingStatus"
              :option-list="ORDER_INTERNAL_SOURCE_STATUS_LIST"
              :placeholder="$t('OrderRuless.Sourcing')"
            />
          </el-form-item>
        </el-col>
        <!-- #endif -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('OrderRuless.Order')" prop="name">
            <BjDateTimerangePicker v-model="queryParamsTime" :placeholder="$t('OrderRuless.Order')"/>
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableOperation="tableOperationProp">
        <el-col>
          <el-button
            v-permission:BusinessOrderSourceIndex_AssignStore
            type="primary"
            :disabled="tableOperationProp.notSingle"
            @click="onAssignStore"
            >{{ $t('OrderRuless.Specify') }}</el-button
          >
          <!-- #ifndef OPEN-SOURCE -->
          <el-button
            v-permission:BusinessOrderSourceIndex_AfreshSource
            type="primary"
            class="main-btn"
            @click="onAfreshSource"
            >{{ $t('OrderRuless.Re') }}</el-button
          >
          <!-- #endif -->
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column
            v-if="col.prop !== 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || false"
            align="center"
            class-name="item"
            :show-overflow-tooltip="col.prop !== 'bjTableAction'"
          >
            <template slot-scope="scope">
              <template v-if="false" />
              <template v-else-if="col.prop === 'orderSn'">
                <span class="link" @click="$toBusinessThirdOrderView(scope.row.orderSn)">{{
                  scope.row[col.prop]
                }}</span>
                <BjCopyIcon class="ml10" :copy="scope.row[col.prop]" />
              </template>
              <template v-else-if="col.prop === 'sourcingSn'">
                <span class="link" @click="onDetail(scope.row)">{{ scope.row[col.prop] }}</span>
                <BjCopyIcon class="ml10" :copy="scope.row[col.prop]" />
              </template>
              <template v-else-if="col.prop === 'innerOrderSn'">
                <span class="link" @click="$toBusinessOrderInternalView(scope.row.innerOrderSn)">{{
                  scope.row[col.prop]
                }}</span>
                <BjCopyIcon class="ml10" :copy="scope.row[col.prop]" />
              </template>
              <template v-else-if="col.prop === 'channel'">
                {{ SCHL_CHANNEL_TYPE.bjGet(scope.row[col.prop]) }}
              </template>
              <template v-else-if="col.prop === 'sourcingStatus'">
                {{ $t(ORDER_INTERNAL_SOURCE_STATUS_LIST.bjGet(scope.row[col.prop])) }}
              </template>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="col.prop === 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || 'right'"
            align="center"
          >
            <template slot-scope="scope">
              <el-button type="text" @click="onDetail(scope.row)">{{ $t('viewText') }}</el-button>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <AppointDelivery ref="specifyDelivery" @confirm="reFresh"></AppointDelivery>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { orderApi } from '@/api';
import { ORDER_INTERNAL_SOURCE_STATUS_LIST } from '@/utils/constants';
import AppointDelivery from './components/AppointDelivery';
const getDefaultForm = () => {
  return {};
};

export default {
  name: 'BusinessOrderSource',
  components: { AppointDelivery },
  mixins: [pageMiXin],
  data() {
    return {
      colSpan: 4,
      ORDER_INTERNAL_SOURCE_STATUS_LIST,
      queryApi: orderApi.getOrderSourcingPage, //
      // 查询参数
      queryParamsTime: [],
      queryParams: {
        orderSn: null, //  "客户订单号/内部订单号/寻源单号"
        channel: null, //  "渠道"
        shopCode: null, //  "店铺code"
        sourcingStatus: null, //  "寻源状态"
        thirdOrderTimeBegin: null, //  "第三方下单时间开始"
        thirdOrderTimeEnd: null, //  "第三方下单时间结束"
      },
      title: '',
      dialogVisible: false,
      // 表单参数
      form: getDefaultForm(),
      // 表单校验
      rules: {},
      labelsVersion: 11,
      labelList: [
        { label: this.$t('OrderRuless.form.Third'), prop: 'orderSn', isCheck: true, disabled: false, width: '190' },
        { label: this.$t('OrderRuless.form.Internal'), prop: 'innerOrderSn', isCheck: true, disabled: false, width: '180' },
        // #ifndef OPEN-SOURCE
        { label: this.$t('OrderRuless.form.Doc'), prop: 'sourcingSn', isCheck: true, disabled: false, width: '185'},
        { label: this.$t('OrderRuless.form.status'), prop: 'sourcingStatus', isCheck: true, disabled: false, width: '145'},
        // #endif
        { label: this.$t('OrderRuless.form.Product'), prop: 'skuNum', isCheck: true, disabled: false, width: '140' },
        // #ifndef OPEN-SOURCE
        { label: this.$t('OrderRuless.form.succeeded'), prop: 'successNum', isCheck: true, disabled: false, width: '125'},
        { label: this.$t('OrderRuless.form.failed'), prop: 'failedNum', isCheck: true, disabled: false, width: '120' },
        { label: this.$t('OrderRuless.form.reason'), prop: 'remarks', isCheck: true, disabled: false, width: '135'},
        // #endif
        { label: this.$t('OrderRuless.form.store'), prop: 'shopName', isCheck: true, disabled: false, width: '90' },
        { label: this.$t('OrderRuless.form.channel'), prop: 'channel', isCheck: true, disabled: false, width: '125' },
        { label: this.$t('OrderRuless.form.ordering'), prop: 'thirdOrderTime', isCheck: true, disabled: false, width: '160'},
        { label: this.$t('OrderRuless.form.time'), prop: 'payTime', isCheck: true, disabled: false, width: '150' },
        // #ifndef OPEN-SOURCE
        { label: this.$t('OrderRuless.form.creation'), prop: 'creationDate', isCheck: true, disabled: false, width: '165'},
        // #endif
      ],
    };
  },
  computed: {
    SCHL_CHANNEL_TYPE() {
      return this.$store.state.values.SCHL_CHANNEL_TYPE || [];
    },
  },
  watch: {
    queryParamsTime(v) {
      this.queryParams.thirdOrderTimeBegin = (v || [])[0];
      this.queryParams.thirdOrderTimeEnd = (v || [])[1];
    },
  },
  mounted() {},
  methods: {
    /** 重置按钮操作 */
    beforeResetSearch() {
      this.queryParamsTime = null;
      this.queryParams.shopCode = null;
      return new Promise(resolve => {
        resolve();
      });
    },
    /** 重新寻源
     * ① 可多选
     * ② 校验选择的寻源单状态：寻源单状态为 寻源失败/寻源取消   的可以重新寻源，
     *    若选中数据含有其他状态的则提示：状态为寻源失败或寻源取消的才可重新寻源，请重新选择
     */
    onAfreshSource() {
      const ids = this.selectedRows.map(e => e.id);

      if (
        !this.selectedRows.every(e => {
          // 全部寻源失败                          部分寻源
          return e.sourcingStatus == '30303' || e.sourcingStatus == '30304';
        })
      ) {
        this.$message.warning(this.$t('OrderRuless.form.Please'));
        return;
      }

      this.$confirm(this.$t('OrderRuless.form.sure'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.reAutoSourceBatchApi(ids);
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('OrderRuless.form.Canceled'),
          });
        });
    },
    /** 指定发货 */
    onAssignStore() {
      const row = this.selectedRows[0];
      // 寻源单状态为寻源失败的可以指定发货
      if (row.sourcingStatus != '30303') {
        this.$message.warning(this.$t('OrderRuless.form.Shipment'));
        return;
      }
      const data = {
        orderId: row.id,
        innerOrderSn: row.innerOrderSn,
        areaCode: row.receiverAddress,
        skuNum: row.skuNum,
        objectVersionNumber: row.objectVersionNumber,
      };
      this.$refs.specifyDelivery.show(data);
    },
    /** 取消寻源 */
    onCancelSource() {
      this.$confirm(this.$t('OrderRuless.form.want'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.$message({
            type: 'success',
            message: this.$t('OrderRuless.form.Cancellation'),
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('OrderRuless.form.Canceled'),
          });
        });
    },
    /** 详情 */
    onDetail(row) {
      this.$toView('BusinessOrderSourceView', row.id);
    },
    reAutoSourceApi(id) {
      orderApi.reAutoSource({ sourceId: id }).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          this.reFresh();
        }
      });
    },
    reAutoSourceBatchApi(ids) {
      orderApi.reAutoSourceBatch({ sourceIdList: ids }).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          this.reFresh();
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
  ::v-deep .bj-page .el-form-item__label{
    display: none;
  }
</style>